import { Component, Input, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { Invoice, InvoiceService, isInvoiceTotalChanged, LoadInvoicesTotal } from '@tokeet-frontend/invoices'
import { Destroyable, untilDestroy } from '@tokeet/tv3-platform'
import { BehaviorSubject, of } from 'rxjs'
import { debounceTime, exhaustMap, filter, map, pairwise, tap } from 'rxjs/operators'

@Component({
  selector: 'app-invoice-total',
  template: `
    <app-loading-value
      [value]="showCurrency ? (total | tokeetCurrency : invoice?.currency) : total"
      [loading]="isLoading"
    ></app-loading-value>
  `,
})
export class InvoiceTotalComponent extends Destroyable implements OnInit {
  private invoice$ = new BehaviorSubject<Invoice>(null)
  @Input() set invoice(invoice: Invoice) {
    this.invoice$.next(invoice)
  }
  get invoice() {
    return this.invoice$.value
  }

  @Input() showCurrency = true

  total: number
  isLoading = true

  constructor(private store: Store<any>, private invoiceService: InvoiceService) {
    super()
  }

  ngOnInit(): void {
    this.invoice$
      .pipe(
        filter((invoice): invoice is Invoice => !!invoice),
        pairwise(),
        filter(([prev, next]) => isInvoiceTotalChanged(prev?.invoiceItems, next?.invoiceItems)),
        untilDestroy(this)
      )
      .subscribe(([_, next]) => {
        this.store.dispatch(LoadInvoicesTotal({ invoiceIds: [next.id] }))
      })

    this.invoice$
      .pipe(
        filter((invoice): invoice is Invoice => !!invoice),
        debounceTime(250),
        tap(() => (this.isLoading = true)),
        exhaustMap((invoice) =>
          !invoice.invoiceTotal
            ? this.invoiceService.total(invoice.id).pipe(map((d) => d.total))
            : of(invoice.invoiceTotal)
        ),
        tap(() => (this.isLoading = false)),
        untilDestroy(this)
      )
      .subscribe((total) => {
        this.total = total || 0
      })
  }
}
